/* Partspick: Shiprocket "Buy Now" on a sold-out model/colour.
   Without this, tapping Buy Now on a sold-out variant does nothing at all.
   Now it shows a clear message instead. */
(function () {
  if (window.__ppSoldOutGuard) return;
  window.__ppSoldOutGuard = true;

  function showMsg(btn) {
    var wrap = btn.closest('.shiprocket-headless') || btn;
    var parent = wrap.parentNode;
    if (!parent) return;
    var m = parent.querySelector('.pp-soldout-msg');
    if (!m) {
      m = document.createElement('p');
      m.className = 'pp-soldout-msg';
      m.setAttribute('role', 'alert');
      m.style.cssText = 'color:#c62828;font-size:14px;font-weight:500;margin:8px 0 0;';
      parent.insertBefore(m, wrap.nextSibling);
    }
    m.textContent = 'Sorry, this model / colour is sold out. Please choose another model or colour.';
    clearTimeout(m._ppT);
    m._ppT = setTimeout(function () { m.textContent = ''; }, 6000);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.sr-headless-checkout');
    if (!btn || btn.closest('cart-drawer')) return;
    if (typeof window.ppIsSelectionComplete === 'function' && !window.ppIsSelectionComplete()) return;
    var form = btn.closest('form');
    var field = form && form.querySelector('input[name="id"]');
    if (!field || !field.value) return;
    var scope = btn.closest('.shopify-section') || document;
    var el = scope.querySelector('script[data-pp-variants]');
    if (!el) return;
    var variants;
    try { variants = JSON.parse(el.textContent); } catch (err) { return; }
    var v = (variants || []).filter(function (x) { return String(x.id) === String(field.value); })[0];
    if (!v || v.available) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    showMsg(btn);
  }, true);
})();
